import { render, staticRenderFns } from "./ContestEnd.vue?vue&type=template&id=1a6aebd6&scoped=true&"
import script from "./ContestEnd.vue?vue&type=script&lang=js&"
export * from "./ContestEnd.vue?vue&type=script&lang=js&"
import style0 from "./ContestEnd.vue?vue&type=style&index=0&id=1a6aebd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6aebd6",
  null
  
)

export default component.exports